import { FC, memo, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Input, Space, Button, Form, DatePicker } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import { Dayjs } from 'dayjs';

import { StyledFilter } from './styled';

export type FormFilters = {
  name?: string;
  date?: [Dayjs | null, Dayjs | null];
  status?: string;
};

interface IFiltersProps {
  onSubmit: (values: FormFilters) => void;
  initialValues?: FormFilters;
  values?: FormFilters;
}

const defaultValues = {
  name: '',
  date: undefined,
  status: ''
};

const Filters: FC<IFiltersProps> = ({ onSubmit, values, initialValues }) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      name: values?.name,
      date: values?.date,
      status: values?.status
    });
  }, [form, values]);

  return (
    <StyledFilter>
      <Form form={form} initialValues={initialValues} onFinish={onSubmit}>
        <Space size={8}>
          <Form.Item style={{ marginBottom: 0 }} name="name">
            <Input
              placeholder={t('filter.search')}
              prefix={<SearchOutlined />}
              size="large"
              style={{ minWidth: 200 }}
            />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }} name="date">
            <DatePicker.RangePicker size="large" style={{ minWidth: 200 }} />
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button type="primary" size="large" onClick={form.submit}>
              {t('appointments.apply')}
            </Button>
          </Form.Item>
          <Form.Item style={{ marginBottom: 0 }}>
            <Button
              size="large"
              onClick={() => {
                onSubmit({ ...defaultValues });
              }}
            >
              {t('appointments.reset')}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </StyledFilter>
  );
};

export default memo(Filters);
